export const DISPLAY_FORMAT_SUMMARY = 'DISPLAY_FORMAT_SUMMARY';
export const DISPLAY_FORMAT_HECTARES = 'DISPLAY_FORMAT_HECTARES';
export const DISPLAY_FORMAT_PERCENTAGE = 'DISPLAY_FORMAT_PERCENTAGE';

export const SBTN_NATURAL_FOREST_LOSS = 'SBTN_NATURAL_FOREST_LOSS';
export const JRC_NATURAL_FOREST_LOSS = 'JRC_NATURAL_FOREST_LOSS';
